module.exports = __webpack_public_path__ + "static/media/compbanner.31cc3867.jpg";